/**
 * Utils Re-export
 * 
 * This file ensures compatibility with imports from '@/lib/utils'
 * by directly importing and re-exporting utilities.
 * 
 * This prevents HMR (Hot Module Replacement) issues and ensures
 * proper function availability during development.
 */

import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes and twMerge for Tailwind conflicts
 * @param inputs - Class values to merge
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Re-export essential utilities that don't have import issues
export * from './utils/idGeneration';
export * from './utils/formatters';
export * from './utils/logger';
export * from './utils/cloning'; 